"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYearCalendarUtilityClass = getYearCalendarUtilityClass;
exports.yearCalendarClasses = void 0;
var _utils = require("@mui/utils");
function getYearCalendarUtilityClass(slot) {
  return (0, _utils.unstable_generateUtilityClass)('MuiYearCalendar', slot);
}
const yearCalendarClasses = exports.yearCalendarClasses = (0, _utils.unstable_generateUtilityClasses)('MuiYearCalendar', ['root']);